import cn from 'classnames';
import InlineProductTemplate from 'components/inline-product-template';
import { useCart } from 'contexts/cart';
import { PdProductItem, isGiftProductItem } from 'interfaces/line-item';
import { formatTitle, isSubscriptionEnabled } from 'utils/product';
import CartItemDescription from '../cart-item-description';
import SubscriptionButton from '../cart-item-description/subscription-button';
import styles from './cart-item.module.css';
import { toCartItem } from 'contexts/cart/utils/to-cart-item';
import { isRedemptionCartItemInput } from 'contexts/type/cart-type';
import { FC } from 'react';

interface PropTypes {
  item: PdProductItem;
  canChangeAmount: boolean;
  canEditSubscription: boolean;
  isCartUpdating?: boolean;
}

// TODO: obsolete – the funnel is disabled, check if there are usages at all
const CartItem: FC<PropTypes> = ({
  canChangeAmount,
  canEditSubscription,
  isCartUpdating,
  item,
}) => {
  const { updateCart } = useCart();
  return (
    <div
      className={cn(
        'relative py-4 lg:px-1.5',
        {
          'pointer-events-none': isCartUpdating,
        },
        'border-grey-100 bg-other-white rounded-lg border px-4 shadow-sm lg:my-0 lg:border-0 lg:px-0 lg:shadow-none'
      )}
    >
      {/* Below div element animates fade-out effect while the cart is loading */}
      <div
        className={cn(
          'z-cart-item-sub-animate absolute top-0 left-0 h-full w-full rounded-lg',
          isCartUpdating ? 'block' : 'hidden',
          isCartUpdating && styles.animationBackground
        )}
      />
      <InlineProductTemplate
        image={item.imageSrc}
        title={formatTitle(item.productTitle)}
        description={
          <CartItemDescription
            item={item}
            canChangeAmount={canChangeAmount}
            onProductQuantityChange={(quantity: number) => {
              // TODO: this is exact copypasta as in src/modules/cart/components/cart-items/cart-item.tsx
              if (!isGiftProductItem(item)) {
                updateCart([
                  {
                    target: toCartItem({ item, shouldQuantity: false }),
                    updateData: {
                      variantId: String(item.variantId),
                      quantity,
                    },
                  },
                ]);
              } else if (isRedemptionCartItemInput(item)) {
                updateCart([
                  {
                    target: toCartItem({ item, shouldQuantity: false }),
                    updateData: {
                      variantId: String(item.variantId),
                      quantity: quantity,
                      points: item.points,
                      redeemItem: true,
                    },
                  },
                ]);
              } else {
                throw new Error('unexpected usage of CartItemDescription');
              }
            }}
          />
        }
      />
      <>
        <span className="bg-grey-100 my-2 block h-px w-full lg:hidden" />
        {!isGiftProductItem(item) && isSubscriptionEnabled(item.tags, item.productId) && (
          <SubscriptionButton item={item} canEditSubscription={canEditSubscription} />
        )}
      </>
    </div>
  );
};

export default CartItem;
